import { ITranslationItems } from '../../../../utils/language';

export const contactFormData: {
  userFeedback: {
    errorGatedContent: ITranslationItems;
    error: ITranslationItems;
    success: ITranslationItems;
    loading: ITranslationItems;
  };
  infoMessage: ITranslationItems;
} = {
  userFeedback: {
    errorGatedContent: {
      title: {
        nl: 'Je download is helaas mislukt',
        en: 'Your download failed',
      },
      description: {
        nl: 'Probeer het opnieuw of stuur een email naar [doorpakken@nl.abnamro.com](mailto:doorpakken@nl.abnamro.com)',
        en: 'Retry downloading the file or send an email to [doorpak@nl.abnamro.com](mailto:doorpak@nl.abnamro.com)',
      },
    },
    error: {
      title: {
        nl: 'Er ging iets mis',
        en: 'Something went wrong',
      },
      description: {
        nl: 'Probeer het opnieuw of stuur een email naar [doorpakken@nl.abnamro.com](mailto:doorpakken@nl.abnamro.com)',
        en: 'Retry downloading the file or send an email to [doorpaken@nl.abnamro.com](mailto:doorpaken@nl.abnamro.com)',
      },
      buttonText: {
        nl: 'Terug naar de vorige pagina',
        en: 'Back to the previous page',
      },
      primaryButtonText: {
        nl: 'Probeer opnieuw',
        en: 'Try again',
      },
      secondaryButtonText: {
        nl: 'Terug naar de vorige pagina',
        en: 'Back to the previous page',
      },
    },
    success: {
      title: {
        nl: 'Bedankt voor je aanvraag',
        en: 'Thank you for your request',
      },
      description: {
        nl: 'We hebben je aanvraag succesvol ontvangen en nemen zo snel mogelijk contact met je op.',
        en: 'We succesfully received your request. We will get in touch as soon as possible.',
      },
      buttonText: {
        nl: 'Terug naar de vorige pagina',
        en: 'Back to the previous page',
      },
      downloadAgain: {
        nl: 'Download nogmaals',
        en: 'Download again',
      },
      shortDescription: {
        nl: 'Je aanvraag is succesvol verstuurd.',
        en: 'Your application has been successfully received.',
      },
    },
    loading: {
      email: { nl: 'Bezig met versturen...', en: 'Sending...' },
      file: { nl: 'Bezig met downloaden...', en: 'Sending...' },
      fallback: {
        nl: 'Een moment geduld alstublieft...',
        en: 'One moment please...',
      },
      externalLinkOne: {
        nl: 'Binnen enkele seconden wordt je doorgestuurd naar de omgeving van ',
      },
      externalLinkTwo: {
        nl: ' om je aanvraag af te maken',
      },
    },
  },
  infoMessage: {
    message: {
      nl: 'We gebruiken de persoonsgegevens die je invult om je aanvraag te verwerken. Meer weten over hoe we omgaan met persoonsgegevens? Je leest het in onze [privacyverklaring](https://www.abnamro.nl/nl/prive/abnamro/privacy/toelichting-privacy.html)',
      en: 'We will use the personal data you enter to process your application. To find out more about how we process your personal data, please read our [privacy statement](https://www.abnamro.nl/en/personal/overabnamro/privacy/explanation-privacy.html).',
    },
    privacyPolicyAndReCaptcha: {
      nl: 'We gebruiken de persoonsgegevens die je invult om je aanvraag te verwerken. Meer weten over hoe Doorpakken omgaat met persoonsgegevens of je afmelden voor communicaties? Ga dan naar onze [privacypagina](https://doorpakken.abnamro.nl/privacy/).',
      en: 'We use the personal data you enter to process your request. Want to learn more about how Doorpakken handles personal data or unsubscribe from communications? Then go to our [privacy page](https://doorpakken.abnamro.nl/privacy/).',
    },
  },
};

export const getExternalLink = (lang: string, label: string) => {
  return `${contactFormData.userFeedback.loading.externalLinkOne[lang]}${label}${contactFormData.userFeedback.loading.externalLinkTwo[lang]}`;
};
